import React from 'react';
import { MicroSearchTiles } from '../../searchTiles';

import { ISearchTile } from '../../homepage/SearchTile/SearchTile.types';

type RenderTiles = Parameters<typeof MicroSearchTiles>[0]['getTilesAndRenderThem'];

export const SearchTiles = ({
  onTileClick,
  tiles,
}: {
  tiles: ISearchTile[],
  onTileClick: (name: string) => void
}) => {
  const renderTiles: RenderTiles = render => tiles.slice(0, 9).map(tile => render({
    serviceName: tile.text,
    serviceImage: tile.source,
    onClick: onTileClick,
  }));

  return (
    <MicroSearchTiles
      renderFirst={() => null}
      getTilesAndRenderThem={renderTiles}
    />
  );
};
